import React from "react";

export default function IndonesiaFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-ind42{fill:#bc0416}"}</style>
        </defs>
        <path
          d="M756.99 1805.8v28.83H282.06v-435.6c79.02-57.58 158.04-115.15 237.05-172.73 28.57 20.75 57.14 41.49 85.71 62.24 4.56 3.3 9.11 6.61 13.66 9.91 4.55 3.31 9.1 6.61 13.65 9.92v497.43h124.86Z"
          className="cls-ind42"
        />
        <path
          d="M632.13 1276.53v51.06l-13.65-9.72c-4.55-3.23-9.11-6.47-13.66-9.71-28.03-19.95-56.07-39.89-84.1-59.83-78.25 56.6-156.5 113.2-234.76 169.81l-3.9.06-59.5.99 300.87-223.35 81.39 60.42c4.55 3.38 9.11 6.76 13.66 10.14s9.1 6.76 13.65 10.13ZM1714.03 1396.29v435.6H1239.1v-26.09h188.27v-546.7c4.55-3.31 9.1-6.63 13.65-9.94 4.55-3.32 9.1-6.63 13.65-9.95 7.16-5.21 14.32-10.43 21.48-15.65 79.3 57.58 158.59 115.15 237.88 172.73Z"
          className="cls-ind42"
        />
        <path
          d="M1777.44 1421.47h-63.41c-80.06-56.95-160.11-113.91-240.17-170.86l-19.19 13.88-13.65 9.87c-4.55 3.29-9.1 6.58-13.65 9.88v-49.6l27.3-20.26 21.9-16.26 300.87 223.35Z"
          className="cls-ind42"
        />
        <path
          d="M1045.34 683.65c-5.43-4.3-10.87-8.6-16.3-12.9-3.83 3.04-7.65 6.08-11.48 9.12C884.53 785.55 751.5 891.23 618.48 996.91v822.55h822.54V996.91c-131.9-104.42-263.79-208.84-395.68-313.26Zm382.03 1122.15H632.13v-786.13c130.97-103.3 261.95-206.59 392.93-309.89 134.11 104.02 268.21 208.04 402.31 312.06v783.96Z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="m1045.35 666.26-16.33-12.93-11.46 9.1-412.74 327.89v842.79h849.85v-842.8l-409.32-324.05Zm382.02 1139.54H632.13v-802.3l390.15-309.95 6.77-5.38 9.04 7.16 389.28 308.18v802.29Z"
          className="cls-ind42"
        />
        <path
          d="M1550.84 1032.43h-109.82l-13.65-10.59c-134.1-104.02-268.2-208.04-402.31-312.06-130.98 103.3-261.96 206.59-392.93 309.89l-13.65 10.77c-4.55.08-9.11.16-13.66.25-32.06.57-64.1 1.15-96.16 1.74l508.9-411.9 12.19-9.87 15.6 12.63c168.49 136.38 336.99 272.76 505.49 409.14ZM1330.96 171.52c-113.4 20.59-155.48 77.74-224.41 66.26-16.13-2.69-39.43-10.08-65.66-32.51v129.87c45.81 25.86 99.76 39.32 149.23 9.46 32.14-18.64 59.04-41.02 95.67-49.97 23.92-5.97 47.09-11.93 71-12.68 6.76-.28 13.52-.39 20.27-.36l7.47-116.23c-12.15.59-30.97 2.05-53.57 6.15Z"
          className="cls-ind42"
        />
        <path
          d="M1175.7 341c-30.21 8.51-75.17 10.86-138.55-18.04 1.25 36.56 2.5 73.12 3.74 109.68 27.78 22.11 51.59 28.26 66.81 30.22 64.02 8.22 100.6-40.51 199.71-62.83 28.68-6.46 52.59-8.43 67.06-9.15l3.63-125.48c-5.16.28-12.94.83-22.31 2.07-87.68 11.6-123.72 57.66-180.09 73.53Z"
          style={{
            fill: "#eae4e4",
          }}
        />
        <rect
          width={27.79}
          height={527.45}
          x={1017.56}
          y={169.56}
          className="cls-ind42"
          rx={13.9}
          ry={13.9}
        />
        {children}
      </g>
    </svg>
  );
}
